import { useCustomizeHeaderContext } from 'contexts/CustomizeHeaderContext';
import { useFooterContext } from 'contexts/CustomizeFooterContext';
import { useRouting } from 'hooks/useRouting';
import React, { useEffect } from 'react';
import { useAuthCheck } from 'components/commons/Main';

export const NotFound = () => {
  const {
    setWithBell,
    setWithNavigation,
    setWithLogo,
  } = useCustomizeHeaderContext();
  const { setType } = useFooterContext();
  useEffect(() => {
    const cleanUpWithBell = setWithBell();
    const cleanUpWithNabigation = setWithNavigation();
    const cleanUpWithLogo = setWithLogo();
    const cleanUpFooterType = setType('DETAILED');
    return () => {
      cleanUpWithBell();
      cleanUpWithNabigation();
      cleanUpWithLogo();
      cleanUpFooterType();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const { pushRouting } = useRouting();
  const { authState } = useAuthCheck();
  const goHome = () =>
    pushRouting({ path: authState === 'success' ? '/home' : '' }, true);
  // NotFoundの場合、htmlのbackgroundColor"#ffffff"に変更
  useEffect(() => {
    document.documentElement.style.backgroundColor = '#ffffff';
    return () => {
      document.documentElement.style.backgroundColor = '';
    };
  }, []);

  return (
    <>
      <div
        className="grid grid-cols-1 min-h-full bg-white items-center text-gray-800 p-6"
        style={{
          placeItems: 'center',
        }}>
        <div className="p-6 pb-14 lg:w-1/2 w-full">
          <img src="/static/images/error_img.svg" alt="error画像" />
        </div>
        <h1 className="text-gray-800 font-bold text-lg mb-4">
          お探しのページが見つかりません
        </h1>
        <span className="text-center text-base">
          一生懸命探したのですが、見つけることができませんでした。
        </span>
        <span className="text-center text-base">
          お探しのページは移動もしくは削除された可能性があります。
        </span>
        <div className="mt-6">
          <button
            className="rounded-lg border border-solid border-gray-500 bg-gray-100 text-gray-800 font-bold text-base py-2 px-8"
            onClick={goHome}>
            みんかぶアセットプランナーに戻る
          </button>
        </div>
      </div>
    </>
  );
};
